function convertUTCToLocalDate(dateString) {
    if (!dateString) {
        return dateString
    }
    const dateObject = new Date(dateString)
    const dateResult = new Date(dateObject.getUTCFullYear(), dateObject.getUTCMonth(), dateObject.getUTCDate(), dateObject.getUTCHours(), dateObject.getUTCMinutes())
    return dateResult
}
export default convertUTCToLocalDate;